import { SpinnerElement } from './Spinner.styles';
import type { SpinnerProps } from './Spinner.types';

export function Spinner({
  size = 16,
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden,
}: SpinnerProps) {
  return (
    <SpinnerElement
      $size={size}
      role={ariaLabel ? 'status' : undefined}
      aria-label={ariaLabel}
      aria-hidden={ariaHidden}
    />
  );
}
